import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "../AxiosClient";

export const getUseSentenceAllDaysAsync = createAsyncThunk(
  "web/useSentenceAllDays",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/useSentenceAllDays`, [], toolkit);
  }
);

export const userTwoDayPreviousWordsAsync = createAsyncThunk(
  "web/userTwoDayPreviousWords",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/userTwoDayPreviousWords`, [], toolkit);
  }
);

export const dayWiseSentencesAsync = createAsyncThunk(
  "web/dayWiseSentences",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/dayWiseSentences/${payload?.id}`,
      [],
      toolkit
    );
  }
);

export const addUserSentencesAsync = createAsyncThunk(
  "web/addUserSentences",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/addUserSentences`, payload, toolkit);
  }
);

export const userWordOfTheDayBookmarksAsync = createAsyncThunk(
  "web/userWordOfTheDayBookmarks",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/userWordOfTheDayBookmarks`, [], toolkit);
  }
);

export const dailyUseSentenceBookmarksAsync = createAsyncThunk(
  "web/dailyUseSentenceBookmarks",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/dailyUseSentenceBookmarks`, [], toolkit);
  }
);
